export default function () {
  return [
    {
      title: '姓名',
      [$field]: 'userName'
    },
    {
      title: '所在党支部',
      [$field]: 'orgName'
    },
    {
      title: '身份证号',
      [$field]: 'idCardNum'
    },
    {
      title: '手机号',
      [$field]: 'phone'
    }
  ]
}